import { useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';

import { ObjectException } from 'global/errors';
import { useFreecodeContextRun, useFreecodeContextData } from 'hooks/useContext';
import services from 'api/services';
const { FreecodeRunService } = services;

const onSaveError = () => {
  throw new ObjectException('Save failed, will not run', 'VALIDATION_ERROR');
};

export default function useCreatorRunFunction(save, updateServerError) {
  const { test, testImpl } = useFreecodeContextData();
  const {
    setRunFunction,
    updateRunResponse,
    setIsRunning,
    isRunningRef,
    codeSolRef,
    levelToRunRef,
    runHiddenRef,
    saveOnRunRef,
  } = useFreecodeContextRun();

  const runFunction = useCallback(async () => {
    if (isRunningRef.current || !test?._id || !testImpl?._id) return;
    setIsRunning(true);
    try {
      if (saveOnRunRef.current && save) await save(onSaveError, true);
      let runBody = {
        test: test?._id,
        testImpl: testImpl?._id,
        code: codeSolRef.current,
        levelToRun: levelToRunRef.current,
      };
      if (runHiddenRef.current) runBody.runHidden = runHiddenRef.current;
      const runResult = await FreecodeRunService.runCreator(runBody);
      if (runResult.serverError) {
        updateServerError(runResult.serverError);
        throw new ObjectException(runResult.serverError?.message || 'Server Error', 'RESPONSE_ERROR');
      }
      updateRunResponse(runResult);
    } catch (error) {
      console.error('Run error:', error);
      toast.error('Run error ' + (error?.message || 'internal Error'));
      updateRunResponse(undefined);
    } finally {
      setIsRunning(false);
    }
  }, [
    isRunningRef,
    test?._id,
    testImpl?._id,
    setIsRunning,
    saveOnRunRef,
    save,
    codeSolRef,
    levelToRunRef,
    runHiddenRef,
    updateRunResponse,
    updateServerError,
  ]);

  useEffect(() => setRunFunction(() => runFunction), [runFunction, setRunFunction]);
}
